import React, { useState } from "react";
import { Icon } from "@culturehq/components";

interface AccordionOption {
  className: string;
  content: React.ReactNode;
  onClick?: () => void;
}

interface AccordionStateOptionsProps {
  accordionOptions: AccordionOption[];
}

const AccordionStateOptions: React.FC<AccordionStateOptionsProps> = ({ accordionOptions }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion">
      <div className="accordion-header" onClick={toggleAccordion}>
        <Icon icon="folder" />
        <span className="accordion-btn">Move Story</span>
        <Icon className="captions-accordion" icon={isOpen ? "chevron-up" : "chevron-down"} />
      </div>
      {isOpen && (
        <div className="accordion-content">
          {accordionOptions?.map((accordionOption, index) => (
            <div
              key={index}
              className={accordionOption.className}
              onClick={() => {
                if (accordionOption.onClick) {
                  accordionOption.onClick();
                }
                setIsOpen(false);
              }}
            >
              {accordionOption.content}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccordionStateOptions;
